module.exports = __webpack_public_path__ + "img/imageAccueilModified3.f0d31d2f.png";